import { memo } from 'react';
import HistoryDatePicker from './HistoryDatePicker';
import HistoryFiltersOptions from './HistoryFiltersOptions';
import HistorySearchBar from './HistorySearchBar';
import HistoryYearPicker from './HistoryYearPicker';
import MarketplaceFilter from './MarketplaceFilter';

const HistoryTableFilters = memo(() => {
	return (
		<>
			<HistorySearchBar />

			<HistoryFiltersOptions />

			<HistoryDatePicker />

			<HistoryYearPicker />

			<MarketplaceFilter />
		</>
	);
});

export default HistoryTableFilters;
